export default __webpack_public_path__ + "static/media/delivery.fe03aaab.svg";